import HttpService from "./HttpService"

class SEOService extends HttpService {
  getActiveCategories(req?: any) {
    return this.get("/public/seo/categories/", {}, null, req)
  }
}

export default new SEOService()
